import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../../../../lib/utils";
import "../overlay-foundations.css";
import { useOverlayPortalContainer } from "../overlay-portal-context";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 8, collisionPadding = 12, ...props }, ref) => {
  const portalContainer = useOverlayPortalContainer();

  return (
    <TooltipPrimitive.Portal container={portalContainer || undefined}>
      <TooltipPrimitive.Content
        ref={ref}
        data-slot="tooltip-content"
        data-ui-overlay-dismiss-layer=""
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          "ui-overlay-content ui-overlay-motion data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=delayed-open]:zoom-in-95 max-h-[var(--radix-tooltip-content-available-height)] max-w-[min(320px,calc(100vw-24px))] overflow-y-auto overscroll-contain rounded-md border px-3 py-2.5 text-xs",
          className,
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const TooltipArrow = TooltipPrimitive.Arrow;

export {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
};
